import { AccountStatus } from 'eve-account-client';

export interface RejectEnrollmentModalData {
  id: string;
  companyName: string;
}

export interface ResendMouEmailModalData {
  id: string;
  status: AccountStatus;
  companyName: string;
}

export enum AlertType {
  ERROR,
  SUCCESS,
}
